export const SOCIAL_LINKS = {
  x: 'https://x.com/zapharapp',
  instagram: 'https://instagram.com/zaphar.app',
  tiktok: 'https://tiktok.com/@user2059071519475',
  facebook: 'https://www.facebook.com/zapharapp',
};

export const SOCIAL_LINK_ITEMS = [
  {
    key: 'x',
    label: 'X',
    href: SOCIAL_LINKS.x,
  },
  {
    key: 'instagram',
    label: 'Instagram',
    href: SOCIAL_LINKS.instagram,
  },
  {
    key: 'tiktok',
    label: 'TikTok',
    href: SOCIAL_LINKS.tiktok,
  },
  {
    key: 'facebook',
    label: 'Facebook',
    href: SOCIAL_LINKS.facebook,
  },
];
